import request from '@/utils/request'

// 资讯管理
export function commonContentList(data) {
    return request({
      url: '/admin/commonNews/list',
      method: 'post',
      data
    })
  }
  export function commonContentUpdate(data) {
    return request({
      url: '/admin/commonNews/update',
      method: 'post',
      data
    })
  }
  export function commonContentSave(data) {
    return request({
      url: '/admin/commonNews/save',
      method: 'post',
      data
    })
  }
  export function commonContentDelete(data) {
    return request({
      url: '/admin/commonNews/delete',
      method: 'post',
      data
    })
  }
//   公告管理
export function commonAntList(data) {
    return request({
      url: '/admin/commonAnnou/list',
      method: 'post',
      data
    }) 
  }
  export function commonAntUpdate(data) {
    return request({
      url: '/admin/commonAnnou/update',
      method: 'post',
      data
    })
  }
  export function commonAnSave(data) {
    return request({ 
      url: '/admin/commonAnnou/save',
      method: 'post',
      data
    })
  }
  export function commonAnDelete(data) {
    return request({
      url: '/admin/commonAnnou/delete',
      method: 'post',
      data
    })
  }
//   成长学院